export const salesOrderStatusOptions = [
  {label: 'Paved', value: 'Paved'},
  {label: 'Cabin', value: 'Cabin'},
  {label: 'Waiting for payment', value: 'WaitingForPayment'},
  {label: 'Paused', value: 'Paused'},
  // { label: 'Geannuleerd', value: 'Cancelled' },
  // { label: 'Niet verwerkt', value: 'NotAssigned' },
];
